// extracted by mini-css-extract-plugin
module.exports = {"statusEl":"Notification_statusEl__zyKXp","wrapperOverlay":"Notification_wrapperOverlay__3ohoZ"};